import { render, staticRenderFns } from "./Combined.vue?vue&type=template&id=64813491&scoped=true"
import script from "./Combined.vue?vue&type=script&lang=js"
export * from "./Combined.vue?vue&type=script&lang=js"
import style0 from "./Combined.vue?vue&type=style&index=0&id=64813491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64813491",
  null
  
)

export default component.exports